angular.module('impactx.colorUtil').service('ColorUtilService', ColorUtilService);

function ColorUtilService() {
    var self = this;

    var rgbColors = [
        '#F44336',
        '#2196F3',
        '#9C27B0',
        '#009688',
        '#4CAF50',
        '#673AB7',
        '#8BC34A',
        '#FFC107',
        '#3F51B5',
        '#CDDC39',
        '#E91E63',
        '#FFEB3B',
        '#00BCD4',
        '#FF9800',
        '#795548',
        '#FF5722',
        '#607D8B'
    ];

    self.getUniqueHSLColor = function (total, hue) {
        var hueBaseValue;

        if (total > 1) {
            hueBaseValue = 360 / (total - 1);
            return {
                h: hueBaseValue / hue,
                s: '80%',
                l: '50%'
            }
        }
        else {
            return {
                h: 207,
                s: '90%',
                l: '54%'
            }
        }
    };

    self.getColor = function (value) {
        if (value >= 0 && value <= rgbColors.length - 1) {
            return rgbColors[value];
        }
        else {
            if (value >= 0) {
                return rgbColors[value % rgbColors.length];
            }
            else {
                return rgbColors[0];
            }
        }
    };

    self.rgbToHsl = function (r, g, b) {
        var r1 = r / 255;
        var g1 = g / 255;
        var b1 = b / 255;

        var maxColor = Math.max(r1, g1, b1);
        var minColor = Math.min(r1, g1, b1);
        var light = (maxColor + minColor) / 2;
        var saturation = 0;
        var hue = 0;
        if (maxColor != minColor) {
            if (light < 0.5) {
                saturation = (maxColor - minColor) / (maxColor + minColor);
            }
            else {
                saturation = (maxColor - minColor) / (2.0 - maxColor - minColor);
            }
            if (r1 == maxColor) {
                hue = (g1 - b1) / (maxColor - minColor);
            }
            else if (g1 == maxColor) {
                hue = 2.0 + (b1 - r1) / (maxColor - minColor);
            }
            else {
                hue = 4.0 + (r1 - g1) / (maxColor - minColor);
            }
        }

        light = light * 100;
        saturation = saturation * 100;
        hue = hue * 60;
        if (hue < 0) {
            hue += 360;
        }

        return {hue: hue, saturation: saturation, light: light};
    };

    self.hslToRgb = function (h, s, l) {
        var r, g, b, m, c, x;

        if (!isFinite(h)) h = 0;
        if (!isFinite(s)) s = 0;
        if (!isFinite(l)) l = 0;

        h /= 60;
        if (h < 0) h = 6 - (-h % 6);
        h %= 6;

        s = Math.max(0, Math.min(1, s / 100));
        l = Math.max(0, Math.min(1, l / 100));

        c = (1 - Math.abs((2 * l) - 1)) * s;
        x = c * (1 - Math.abs((h % 2) - 1));

        if (h < 1) {
            r = c;
            g = x;
            b = 0
        }
        else if (h < 2) {
            r = x;
            g = c;
            b = 0
        }
        else if (h < 3) {
            r = 0;
            g = c;
            b = x
        }
        else if (h < 4) {
            r = 0;
            g = x;
            b = c
        }
        else if (h < 5) {
            r = x;
            g = 0;
            b = c
        }
        else {
            r = c;
            g = 0;
            b = x
        }

        m = l - c / 2;
        r = Math.round((r + m) * 255);
        g = Math.round((g + m) * 255);
        b = Math.round((b + m) * 255);

        return {r: r, g: g, b: b}
    };

    self.rgbToHex = function (red, green, blue) {
        var rgb = blue | (green << 8) | (red << 16);
        return (0x1000000 + rgb).toString(16).slice(1)
    };

    self.hexToRgb = function (hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    };

    self.rgbToHsv = function (r, g, b) {
        r = r / 255;
        g = g / 255;
        b = b / 255;

        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, v = max;

        var d = max - min;
        s = max === 0 ? 0 : d / max;

        if (max == min) {
            h = 0; // achromatic
        }
        else {
            switch (max) {
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {hue: h * 360, saturation: s * 100, value: v * 100};
    };

    self.hsvToRgb = function (h, s, v) {
        var r, g, b, i, f, p, q, t;
        h = h / 360;
        s = s / 100;
        v = v / 100;

        i = Math.floor(h * 6);
        f = h * 6 - i;
        p = v * (1 - s);
        q = v * (1 - f * s);
        t = v * (1 - (1 - f) * s);
        switch (i % 6) {
            case 0:
                r = v, g = t, b = p;
                break;
            case 1:
                r = q, g = v, b = p;
                break;
            case 2:
                r = p, g = v, b = t;
                break;
            case 3:
                r = p, g = q, b = v;
                break;
            case 4:
                r = t, g = p, b = v;
                break;
            case 5:
                r = v, g = p, b = q;
                break;
        }
        return {
            r: Math.round(r * 255),
            g: Math.round(g * 255),
            b: Math.round(b * 255)
        };
    };

    return {
        getUniqueHSLColor: self.getUniqueHSLColor,
        getColor: self.getColor,
        rgbToHsl: self.rgbToHsl,
        hslToRgb: self.hslToRgb,
        rgbToHsv: self.rgbToHsv,
        hsvToRgb: self.hsvToRgb,
        rgbToHex: self.rgbToHex,
        hexToRgb: self.hexToRgb,
    };
}